import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
const UseStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
});
export default function card(props) {
  const classes = UseStyles();
  const { Header, FTD, MTD, Allocated, Pending } = props;
  console.log(Allocated, Pending);
  return (
    <div className="row">
      <div className="col-lg-12 col-sm-12 col-12">
        <div className="card jr-card-intra shadow text-center">
          <div className="card-header py-3 d-flex align-items-center">
            <h3 className="mb-0">{Header}</h3>
            <span className="badge badge-primary ml-auto"></span>
          </div>
          {FTD > -1 && MTD > -1 ? (
            <div className="row no-gutters">
              <div className="col-6">
                <div className="stack-order py-4 px-2">
                  <h1 className="chart-f30">{FTD}</h1>
                  <span className="h3">FTD</span>
                  {/* <span className='h5 text-green'>
                  <i className='zmdi zmdi-long-arrow-return zmdi-hc-fw zmdi-hc-rotate-90' />
                  20%
                </span> */}
                </div>
              </div>

              <div className="col-6">
                <div className="stack-order py-4 px-2">
                  <h1 className="chart-f30">{MTD}</h1>
                  <span className="h3">MTD</span>
                  {/* <span className='h5 text-red'>
                  <i className='zmdi zmdi-long-arrow-return zmdi-hc-fw zmdi-hc-rotate-90' />
                  20%
                </span> */}
                </div>
              </div>
            </div>
          ) : (
            Allocated > -1 &&
            Pending > -1 && (
              <div className="row no-gutters">
                <div className="col-6">
                  <div className="stack-order py-4 px-2">
                    <h1 className="chart-f30">{Allocated}</h1>
                    <span className="h3">Allocated</span>
                    {/* <span className='h5 text-green'>
                  <i className='zmdi zmdi-long-arrow-return zmdi-hc-fw zmdi-hc-rotate-90' />
                  20%
                </span> */}
                  </div>
                </div>

                <div className="col-6">
                  <div className="stack-order py-4 px-2">
                    <h1 className="chart-f30">{Pending}</h1>
                    <span className="h3">Pending</span>
                    {/* <span className='h5 text-red'>
                  <i className='zmdi zmdi-long-arrow-return zmdi-hc-fw zmdi-hc-rotate-90' />
                  20%
                </span> */}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
    // <Card className={classes.root}>
    //   <CardContent>
    //     <Typography gutterBottom variant='h5' component='h1'>
    //       {Header}
    //     </Typography>
    //     <Typography variant='body2' color='textSecondary' component='p'>
    //       FTD --{FTD}
    //     </Typography>
    //     <Typography variant='body2' color='textSecondary' component='p'>
    //       MTD --{MTD}
    //     </Typography>
    //   </CardContent>
    // </Card>
  );
}
